import { render, staticRenderFns } from "./avalaibleTimes.vue?vue&type=template&id=4b061920&scoped=true&"
import script from "./avalaibleTimes.vue?vue&type=script&lang=js&"
export * from "./avalaibleTimes.vue?vue&type=script&lang=js&"
import style0 from "./avalaibleTimes.vue?vue&type=style&index=0&id=4b061920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b061920",
  null
  
)

export default component.exports